(() => {
  // app/scripts/common/component/cartUpdateComponent.js
  !customElements.get("cart-update-component") && customElements.define("cart-update-component", class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", e => {
        this.currentTarget = e.target;
        let {
          value
        } = this.currentTarget;
        if (this.currentTarget.type == "checkbox") {
          value = this.currentTarget.checked;
        }
        this.onUpdate(value);
        if (this.querySelector(".jsValue")) this.querySelector(".jsValue").innerHTML = this.currentTarget.dataset.value || value;
      });
    }
    onUpdate(value) {
      const attributes = {
        [this.dataset.type]: value
      };
      this.disabled = true;
      this.cartUpdate(attributes);
    }
    set disabled(value) {
      this.classList.toggle("event-none", value);
    }
    set setValue(element) {
      this.currentTarget = element;
      let {
        value
      } = element;
      if (element.type == "checkbox") {
        value = element.checked;
      }
      this.onUpdate(value);
      if (this.querySelector(".jsValue")) this.querySelector(".jsValue").innerHTML = element.dataset.value || value;
    }
    async onFinished() {
      this.updateState();
      this.disabled = false;
    }
    async updateState() {
      var _this$closest;
      const {
        sectionId
      } = this.dataset;
      if (!sectionId) return;
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += sectionId;
      let html = await fetch(url);
      html = await html.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      (_this$closest = this.closest("filter-component")) === null || _this$closest === void 0 || _this$closest.render(div);
      if (this.currentTarget.closest("details[open]") && this.currentTarget.closest("filter-component") && window.matchMedia("(max-width: 991px)").matches) return;
      if (this.currentTarget.closest("details[open]")) this.currentTarget.closest("details[open]").open = false;
    }
  });

  // app/scripts/cart-update-attr.js
  document.addEventListener("click", function (event) {
    const targetElement = event.target;
    if (!document.querySelector(".jsCloseSortBy").contains(targetElement)) {
      targetElement.open = false;
      document.querySelector(".jsCloseSortBy").removeAttribute("open");
    }
  });
})();
